import dynamic from "next/dynamic";

export const StatisticHexagon = dynamic(() => import("./component"));
